import React from 'react';

interface ComponentSelectionProps {
  componentCount: number;
  onComponentCountChange: (count: number) => void;
  disabled?: boolean;
}

const ComponentSelection: React.FC<ComponentSelectionProps> = ({ 
  componentCount, 
  onComponentCountChange,
  disabled = false
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Select Number of Components</h3>
      
      <div className="space-y-2">
        <div className="flex justify-between">
          <span>Components</span>
          <span className="font-medium">{componentCount}</span>
        </div>
        
        <input
          type="range"
          min="1"
          max="30"
          value={componentCount}
          onChange={(e) => onComponentCountChange(parseInt(e.target.value))}
          className={`w-full ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={disabled}
        />
        
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>1</span>
          <span>30</span>
        </div>
        
        <div className="text-sm text-muted-foreground mt-2 inline-flex px-2 py-1 rounded-md bg-secondary">
          Adds {componentCount * 3} hours to estimate
        </div>
      </div>
    </div>
  );
};

export default ComponentSelection; 